import styled from "styled-components";
import colors from "@styling/colors";
import { borderRadius, spacing } from "@styling/sizing";
import { fontSizes } from "@styling/fonts";

export const TextArea = styled.textarea`
  width: 100%;
  padding: ${spacing.x2}px;
  border: 1px solid ${colors.border};
  border-radius: ${borderRadius.regular}px;
  font-size: ${fontSizes.regular}px;
  color: ${colors.text};
  background-color: ${colors.background};
  min-height: 80px;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: ${colors.primary};
  }

  &::placeholder {
    color: ${colors.textMuted};
  }
`;
